import { render, staticRenderFns } from "./MedicalScoreboardTimeTranslate.vue?vue&type=template&id=53d23db0&"
import script from "./MedicalScoreboardTimeTranslate.vue?vue&type=script&lang=js&"
export * from "./MedicalScoreboardTimeTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QList,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign({QItem,QList,QItemSection,QIcon}, component.options.components || {})
